/** @format */

import {
    MAXIMUM_ROLL_DIAMETER,
    ROLL_SIZE_TYPE_DIAMETER,
    ROLL_SIZE_TYPE_QTY,
    SUBSTRATE_THICKNESSES
} from 'frontier-constants';

const calcCores = ({
    across,
    frameColumnCells,
    frameFiles,
    length,
    substrateId,
    rollMax,
    isSpecialRollQty,
    isFewestPossibleRolls,
    isHighOpacityWhite,
    designQty // New parameter for the number of unique designs
}) => {
    const rollSizeTypeId =
        rollMax > MAXIMUM_ROLL_DIAMETER ? ROLL_SIZE_TYPE_QTY : ROLL_SIZE_TYPE_DIAMETER;
    let maxQty;

    if (isSpecialRollQty) {
        if (rollSizeTypeId === ROLL_SIZE_TYPE_QTY) {
            maxQty =
                rollMax > 0
                    ? rollMax
                    : calcQtyFromDiameter({
                          diameter: MAXIMUM_ROLL_DIAMETER,
                          length,
                          substrateId,
                          isHighOpacityWhite
                      });
        } else {
            maxQty = calcQtyFromDiameter({
                diameter: rollMax > 0 ? rollMax : MAXIMUM_ROLL_DIAMETER,
                length,
                substrateId,
                isHighOpacityWhite
            });
        }
    } else {
        maxQty = calcQtyFromDiameter({
            diameter: MAXIMUM_ROLL_DIAMETER,
            length,
            substrateId,
            isHighOpacityWhite
        });
    }

    let rollsPerColumn;

    if (isFewestPossibleRolls && isSpecialRollQty) {
        // When fewest possible rolls is enabled, we want to create the largest possible rolls
        // This means filling each roll to its maximum capacity before creating a new roll

        // Calculate total labels across all frame files
        const totalLabels = frameFiles.reduce((total, ff) => {
            return total + (ff.total_copies - ff.setup_copies) * frameColumnCells;
        }, 0);

        // Calculate minimum number of rolls needed by maximizing each roll's capacity
        rollsPerColumn = Math.ceil(totalLabels / maxQty);
    } else {
        // Default behavior: calculate rolls per frame file and sum them up
        rollsPerColumn = frameFiles.reduce((rollCount, ff) => {
            const labelCount = (ff.total_copies - ff.setup_copies) * frameColumnCells;
            return (rollCount += Math.ceil(labelCount / maxQty));
        }, 0);
    }

    // Calculate the total cores based on rolls per column and across value
    const totalCores = rollsPerColumn * across;

    // Apply the constraint: minimum cores must be at least equal to the number of unique designs
    // If designQty is provided and is a valid number
    if (designQty && !isNaN(designQty) && designQty > 0) {
        // Return the maximum of calculated cores and designQty
        return Math.max(totalCores, designQty);
    }

    // If designQty is not provided or invalid, return the calculated cores
    return totalCores;
};

const calcDiameterFromQty = ({qty, length, substrateId, isHighOpacityWhite}) => {
    const runLength = Math.ceil(parseInt(qty) * (length + 0.125));
    const substrateThickness = SUBSTRATE_THICKNESSES.find(({id}) => id === substrateId);
    let T = substrateThickness.default;
    if (isHighOpacityWhite && substrateThickness.withHighOpacityWhite) {
        T = substrateThickness.withHighOpacityWhite;
    }
    const coreRadius = 1.625; // Outer Core Diameter
    return (
        Math.round((Math.sqrt((runLength * T) / Math.PI + Math.pow(coreRadius, 2)) * 2) / 0.5) * 0.5
    );
    // =SQRT(RunLength * MaterialThickness / PI() + CoreDiameter^2) * 2
};

/**
 *
 * @param diameter - Cannot be less than the size of the core
 * @param width
 * @param length
 * @param repeatLength
 * @param substrateId
 * @returns {number}
 */
const calcQtyFromDiameter = ({diameter, length, substrateId, isHighOpacityWhite}) => {
    const substrateThickness = SUBSTRATE_THICKNESSES.find(({id}) => id === substrateId);
    if (!substrateThickness) {
        console.log('This substrate does not have a thickness. Is it a carton substrate?');
        return 0;
    }
    let T = substrateThickness.default;
    if (isHighOpacityWhite && substrateThickness.withHighOpacityWhite) {
        T = substrateThickness.withHighOpacityWhite;
    }
    const core = Math.pow(1.625, 2) * Math.PI;
    const runLength = Math.ceil((Math.pow(diameter, 2) * Math.PI) / (4 * T) - core / T);

    return Math.round(Math.ceil(runLength / (length + 0.125)) / 10) * 10;
};

export {calcCores, calcQtyFromDiameter, calcDiameterFromQty};
